export const perfilChangeLinkedin = {
  "LinkedIn": "LinkedIn",
  "Fechar": "Fechar",
  "Aviso": "Aviso",
  "Dados atualizado com sucesso.": "Dados atualizado com sucesso.",
  "Por favor, informe um perfil válido. Caso não saiba como, acesse o linkedin, clique em visualizar perfil e copie a url do navegador.": "Por favor, informe um perfil válido. Caso não saiba como, acesse o linkedin, clique em visualizar perfil e copie a url do navegador.",
  "Whatsapp": "Whatsapp",
  "Salvar": "Salvar",
  "Campo obrigatório.": "Campo obrigatório."
};



// WEBPACK FOOTER //
// ./src/resources/ptBR/perfilChangeLinkedin.js